import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import ServicesContent from "./components/ServicesContent";

export default function ServicesPage() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <ServicesContent />
      <Footer />
    </div>
  );
}
